/**
 * Identifies the TipTap node type for mention extensions.
 * Used as the `name` on the extension and as the `data-type` attribute in the DOM.
 */
export enum MentionType {
  USER = "userMention",
  REF = "refMention"
}
